<template>
	<div id="voiceSceneTeacherDetail">
		<div class="top">
			<div class="btn-box">
				<div><a v-if="preId" @click="queryGrade(preId)">考核</a></div>
				<div><a v-if="nextId" @click="queryGrade(nextId)">下一通考核</a></div>
			</div>
		</div>
    <div class="bottom">
  		<div class="header">考核得分与建议</div>
  		<div class="content wx">
  			<div class="video">
  				<span>考核录音</span>
					<audio :src="videoUrl" controls="controls"></audio>
				</div>
				<template v-if="effectStatus == 0">
					<!--无效练习-->
					<div class="text-box">
	    			<p><img src="@/assets/images/voiceScene/icon_wuxiao.png" /></p>
	    			<p>考核无效</p>
	    			<p class="wuxiao">{{ effectReason }}</p>
	    		</div>
  			</template>
  			<template v-else-if="effectStatus == 1">
    			<!--评分结果-->
					<div class="score">
						<div class="title">
							<span>考核结果</span>
							<span class="blue">{{ gradeScore }}分</span>
						</div>
						<div class="grade" v-for="(f, index) in gradeList">
							<div class="first">
								<span class="name">{{ f.name }}</span>
								<span class="blue gradescore">{{ f.gradeScore }}分</span>
							</div>
							<div class="second" v-for="(s, key) in f.childList">
								<div class="parent">
									<span class="name">{{ s.name }}</span>
									<span class="red gradescore">{{ s.gradeScore < 0 ? s.gradeScore : '-'+(s.score - s.gradeScore)}}分</span>
									<span :class="{'el-icon-arrow-right': !s.isClickSecond, 'el-icon-arrow-down': s.isClickSecond}" @click="clickSecond(index, key)" :key="key+keyData"></span>
								</div>
								<div :class="{'third': true, 'none': !s.isClickSecond}" :key="key+keyData" v-for="(t, key) in s.childList">
									<span class="name">{{ t.name }}</span>
									<span class="red gradescore">{{ t.gradeScore}}分</span>
								</div>
							</div>
						</div>
					</div>
					<div class="evaluate">
						<div class="title">
							<span>考核建议</span>
						</div>
						<p v-for="(e, key) in evaluateList">
							<span class="dot"></span>
							{{ key+1 }}、{{ e }}
						</p>
					</div>
				</template>
				<template v-else>
					<!--待评分-->
					<div class="text-box">
	    			<p><img src="@/assets/images/voiceScene/icon_dafen.png" /></p>
	    			<p>待评分</p>
	    		</div>
  			</template>
  		</div>
  	</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				id: this.$route.query.id,
				videoUrl: '', //录音文件
				gradeState: '', //评分状态
				effectStatus: null, //是否有效
				effectReason: '', //无效原因
				gradeScore: '', //得分
				gradeList: '', //点评内容
				evaluateList: [], //练习建议
				preId: '', //上一条记录
				nextId: '', //下一条记录
				keyData: 0, //更新页面
			}
		},
		created() {
			
		},
		mounted() {
			this.queryGrade(this.id);
		},
		methods: {
			queryGrade(id) {
				let data = {
					'id': id
				}
				this.$http.post(API_ROOT.college + '/voiceExerciseRecord/queryDetail', data).then(response=>{
					var result = response.data;
					if(result.success) {
						this.videoUrl = result.data.videoUrl;
						this.gradeState = result.data.gradeState;
						this.effectStatus = result.data.effectStatus;
						this.effectReason = result.data.effectReason;
						this.gradeScore = result.data.gradeScore;
						this.gradeList = result.data.gradeList;
						this.evaluateList = result.data.evaluateList;
						this.preId = result.data.preId;
						this.nextId = result.data.nextId;
					}else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			//点击二级菜单
			clickSecond(index, key) {
				this.$set(this.gradeList[index].childList[key], 'isClickSecond', !this.gradeList[index].childList[key].isClickSecond);
				this.keyData+=1;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// ./src/page/newVoiceScene/kaoheTeacherDetail.vue